export default __webpack_public_path__ + "static/media/XEMP-28.5240e316.jpg";